import React from 'react';

interface ShowProps {
  when: boolean;
  children: React.ReactNode;
  fallback?: React.ReactNode;
}

export const Show: React.FC<ShowProps> = ({ when, children, fallback = null }) => {
  return <>{when ? children : fallback}</>;
};
